// 标准职业赛 Tournament Draft 顺序（20 步）：
// Phase 1: 6 ban + 6 pick；Phase 2: 4 ban + 4 pick
// type: 'ban' | 'pick'，team: 'blue' | 'red'，slot: 该队此类型槽位 index (0..4 picks / 0..4 bans)

export const DRAFT_SEQUENCE = [
  { type: 'ban',  team: 'blue', slot: 0 },  // 0  - BAN PHASE 1
  { type: 'ban',  team: 'red',  slot: 0 },  // 1
  { type: 'ban',  team: 'blue', slot: 1 },  // 2
  { type: 'ban',  team: 'red',  slot: 1 },  // 3
  { type: 'ban',  team: 'blue', slot: 2 },  // 4
  { type: 'ban',  team: 'red',  slot: 2 },  // 5
  { type: 'pick', team: 'blue', slot: 0 },  // 6  - PICK PHASE 1
  { type: 'pick', team: 'red',  slot: 0 },  // 7
  { type: 'pick', team: 'red',  slot: 1 },  // 8
  { type: 'pick', team: 'blue', slot: 1 },  // 9
  { type: 'pick', team: 'blue', slot: 2 },  // 10
  { type: 'pick', team: 'red',  slot: 2 },  // 11
  { type: 'ban',  team: 'red',  slot: 3 },  // 12 - BAN PHASE 2
  { type: 'ban',  team: 'blue', slot: 3 },  // 13
  { type: 'ban',  team: 'red',  slot: 4 },  // 14
  { type: 'ban',  team: 'blue', slot: 4 },  // 15
  { type: 'pick', team: 'red',  slot: 3 },  // 16 - PICK PHASE 2
  { type: 'pick', team: 'blue', slot: 3 },  // 17
  { type: 'pick', team: 'blue', slot: 4 },  // 18
  { type: 'pick', team: 'red',  slot: 4 },  // 19
];

export const getPhaseName = (stepIndex) => {
  if (stepIndex < 6) return 'BAN PHASE 1';
  if (stepIndex < 12) return 'PICK PHASE 1';
  if (stepIndex < 16) return 'BAN PHASE 2';
  if (stepIndex < 20) return 'PICK PHASE 2';
  return 'DRAFT COMPLETE';
};

export const DEFAULT_STEP_SECONDS = 30;

// 根据"谁先手"生成 BP 序列。
// firstSide = 'blue' 时返回原版（蓝先手）；'red' 时把所有 blue/red 互换。
// 这样可以零侵入地支持红方先手（仅每局开始前可切换）。
export const generateDraftSequence = (firstSide = 'blue') => {
  if (firstSide === 'blue') return DRAFT_SEQUENCE;
  return DRAFT_SEQUENCE.map((step) => ({
    ...step,
    team: step.team === 'blue' ? 'red' : 'blue',
  }));
};
